import { Command, CommandResult } from '@/_core/cqrs/types/commands';

export class AddNewProduct extends Command<AddNewProductResult> {
    constructor(public Id: string, public Name: string) {
        super('AddNewProduct');
    }
}

export interface AddNewProductResult extends CommandResult {
    Slug: string;
}

export class ChangeProductName extends Command<CommandResult> {
    constructor(public Id: string, public Name: string) {
        super('ChangeProductName');
    }
}

export class ChangeProductSlug extends Command<ChangeProductSlugResult> {
    constructor(public Id: string, public Slug: string) {
        super('ChangeProductSlug');
    }
}

export interface ChangeProductSlugResult extends CommandResult {
    Slug: string;
}

export class MoveAssets extends Command<CommandResult> {
    constructor(
        public FromProductId: string,
        public ToProductId: string,
        public SelectedStorymapIds: string[],
        public SelectedStorymapTemplateIds: string[],
        public SelectedRoadmapIds: string[],
        public SelectedInsightFolderIds: string[],
        public SelectedIdeaLabelIds: string[],
        public ShouldMoveAllInsights: boolean,
        public ShouldMoveAllIdeas: boolean
    ) {
        super('MoveAssets');
    }
}

export class DeleteProduct extends Command<CommandResult> {
    constructor(public ProductSlug: string) {
        super('DeleteProduct');
    }
}
